import React, { useState, useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  onAuthStateChanged,
  GoogleAuthProvider,
  signInWithPopup,
  signOut
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { Loader2 } from 'lucide-react';
import LandingPage from './LandingPage';
import ProjectsList from './components/ProjectsList';
import ProjectDetails from './components/ProjectDetails';
// import { migrateData } from './migration'; // Removed after migration

// --- Firebase Configuration ---
const firebaseConfig = {
  apiKey: "AIzaSyANQFQgt3udUAb1wl8SeiJbODAkSXgpIqs",
  authDomain: "milestone-manager-6a994.firebaseapp.com",
  projectId: "milestone-manager-6a994",
  storageBucket: "milestone-manager-6a994.firebasestorage.app",
  messagingSenderId: "592900125240",
  appId: "1:592900125240:web:78667a380dc8a688826ccd"
};

const app = initializeApp(Object.keys(firebaseConfig).length > 0 ? firebaseConfig : { apiKey: "placeholder" });
const auth = getAuth(app);
const db = getFirestore(app);
const appId = 'milestone-manager-app';

// --- Gemini Helper ---
const generateGeminiContent = async (prompt) => {
  const apiKey = process.env.REACT_APP_GEMINI_API_KEY || ""; 
  if (!apiKey) return "Configuration Error: API Key is missing.";
  
  const url = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-preview-09-2025:generateContent?key=${apiKey}`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ contents: [{ parts: [{ text: prompt }] }] })
    });
    if (!response.ok) throw new Error(`API Error: ${response.status}`);
    const data = await response.json();
    return data.candidates?.[0]?.content?.parts?.[0]?.text || "No response generated.";
  } catch (error) {
    console.error("Gemini API Error:", error);
    return "Sorry, I couldn't generate a response at this time.";
  }
};

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentProject, setCurrentProject] = useState(null); // null = show list, object = show details

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      
      if (currentUser) {
        // Migration logic removed
        // await migrateData(db, currentUser.uid, appId);
      }
      
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    setCurrentProject(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <Loader2 className="animate-spin text-blue-600" size={40} />
      </div>
    );
  }

  if (!user) {
    return <LandingPage onLogin={handleGoogleLogin} />;
  }

  return (
    <>
      {currentProject ? (
        <ProjectDetails 
          project={currentProject}
          user={user}
          db={db}
          appId={appId}
          onBack={() => setCurrentProject(null)}
          onLogout={handleLogout}
          generateContent={generateGeminiContent}
        />
      ) : (
        <ProjectsList 
          user={user}
          db={db}
          appId={appId}
          onSelectProject={setCurrentProject}
          onLogout={handleLogout}
        />
      )}
    </>
  );
}
